import { apiDelete, apiGet, apiPatch, apiPost } from 'api/service';

export const listSites = (params = '') => apiGet(`/api/site-watch/${params}`);
export const addSite = (url) => apiPost('/api/site-watch/', { url });
export const updateSite = (id, body) => apiPatch(`/api/site-watch/${id}/`, body);
export const removeSite = (id) => apiDelete(`/api/site-watch/${id}/`);
export const checkSite = (id) => apiPost(`/api/site-watch/${id}/check/`);
export const syncSites = (userTarget) => apiPost('/api/site-watch/sync/', { user_target: userTarget });
export const listChanges = (query = '') => apiGet(`/api/site-watch/changes/${query}`);
export const markSeen = (watch) => apiPost('/api/site-watch/mark-seen/', watch ? { watch } : {});
export const getAlertSettings = () => apiGet('/api/site-watch/settings/');
export const saveAlertSettings = (body) => apiPatch('/api/site-watch/settings/', body);
export const sendTestAlert = () => apiPost('/api/site-watch/settings/test/');
